import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getOperationEntityByType,
    GetCollectionPoints,
    saveCardUpload,
    getAllOperationEntitiesForDropDown
};

async function getOperationEntityByType(type, groupID) {
    const dataArray = [];
    if(type === "1") {
        const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + groupID);
        for (let item of Object.entries(response.data)) {
            if(item[1]["isActive"] === true)
                dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    } else if(type === "2") {
        const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID);
        for (let item of Object.entries(response.data)) {
            if(item[1]["isActive"] === true)
                dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return dataArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function GetCollectionPoints(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointsForCustomerUpload', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
   
    return collectionPointArray;
}

async function saveCardUpload(cardFilterModule){
    const response = await CommonPost('/api/Card/CardUpload', null, cardFilterModule);
    return response;
}



